var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5833 25.75C21.5833 23.5399 20.7054 21.4202 19.1426 19.8574C17.5798 18.2946 15.4601 17.4167 13.25 17.4167M13.25 17.4167C11.0399 17.4167 8.92025 18.2946 7.35744 19.8574C5.79464 21.4202 4.91667 23.5399 4.91667 25.75M13.25 17.4167C16.3182 17.4167 18.8056 14.9294 18.8056 11.8611C18.8056 8.79286 16.3182 6.30556 13.25 6.30556C10.1818 6.30556 7.69444 8.79286 7.69444 11.8611C7.69444 14.9294 10.1818 17.4167 13.25 17.4167ZM3.52778 0.75H22.9722C24.5063 0.75 25.75 1.99365 25.75 3.52778V22.9722C25.75 24.5063 24.5063 25.75 22.9722 25.75H3.52778C1.99365 25.75 0.75 24.5063 0.75 22.9722V3.52778C0.75 1.99365 1.99365 0.75 3.52778 0.75Z",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetails);
export default __webpack_public_path__ + "static/media/PersonalDetails.f018ddc08e606b3858ca9adff5ffb1b0.svg";
export { ForwardRef as ReactComponent };